<!-- Btra Botones Extra -->

<template>
    <div class="baseBtraExtra">           
      <btra        
        :btra="botonera"
        :modulo="modulo"
        :showDisabled="showDisabled"
        @onEvent="eventBtns">
          <template  v-for="elem in botonera"
            v-slot:[`${elem.accion}`]="{item,show,disabled}">
              <slot :name="item.accion" :item="item" :show="show" :disabled="disabled"></slot>              
          </template>
          
      </btra>
    </div>
</template>



<script>
   
    import plugs from "@/common/general_plugs";
    const btra = () => plugs.groute("baseBtra.vue", "base");

    export default {
      name:'baseBtraExtra',    
      components: { btra },
      props: {
        permExtra: { type: [Array, Object], default:()=> [] },       
        modulo: { type: Object, default:null },
        showDisabled: { type: [Number, Boolean], default: 1 }
      },

      data() {
        return {
          botonera:[]
        }
      },


      created() {
        this.mountBtra();
      },


      methods: {

        // gestor de eventos
        eventBtns(evt) {
          console.log("*** event_btraextra. Emit btraextra: ", evt, " ***");
          this.$emit("onEvent", { accion: evt.accion });
        },


        // monto array de botones a mostrar
        mountBtra() {        
          // obtengo la botonera Extra (la definida en modulo.btnsAccion + la btra recibida) 
          // y la filtro por los permisos recibidos
          this.botonera= this.modulo.btnsAccion.slice();         
          
          // filtro los botones por los permisos recibidos
          this.filterPermBtns();
        },


        // filtro botón por su permiso
        filterPermBtns() { 
          // si no he recibido permisos, devuelvo el array de botones sin modificarlo por permisos
          if (Array.isArray(this.permExtra)) return;

          this.botonera.forEach(elem => {              
            elem.show= typeof this.permExtra[elem.accion]!== 'undefined'? Number(this.permExtra[elem.accion]) : 1;
          });
        
        },

      }
    };
</script>
